const isTeamCreatedByCustomerSuccess = (state) => {
  return state.currentAccount &&
    state.currentAccount.id &&
    (state.currentAccount.createdFrom == null || state.currentAccount.createdFrom === 'admin')
}

const isUsedLicenseGreaterThanQuota = (state) => {
  return state.currentAccount &&
    state.currentAccount.id &&
    state.currentAccount.numberOfUsedLicenses > state.currentAccount.licenseQuantity
}

const isPaidTeamPlan = (state) => {
  return state.currentAccount &&
    state.currentAccount.id &&
    state.currentAccount.plan !== 'free' && state.currentAccount.plan !== null
}

export default {
  isTeamCreatedByCustomerSuccess,
  isUsedLicenseGreaterThanQuota,
  isPaidTeamPlan,
}
